import { FC, useMemo } from 'react';
import { Route } from 'react-router-dom';

import useCasinoRoutes from '../router/use-casino-routes';
import { getRelativePaths } from '~/utils/pathname';

import CasinoSeoHeader from '../casino-shared/casino-seo-header';
import CasinoSubNavigationSeoHeader from '../casino-shared/subnavigation/casino-subnavigation-seo-header';
import { TracedRoutes } from '@comeon/error-reporter';

/**
 * Sets general page title and description.
 *
 * Pages that need more specific or dynamic title and description may override whatever
 * is set here using the default override behavior provided by react-helmet.
 */
const LiveCasinoSeoHeaderContainer: FC = () => {
	const {
		ROUTE_LIVE_CASINO,
		ROUTE_LIVE_CASINO_EXPLORE,
		ROUTE_LIVE_CASINO_SUBMENU,
		ROUTE_LIVE_CASINO_ALL_GAMES,
		ROUTE_LIVE_CASINO_MY_GAMES
	} = useCasinoRoutes();

	const paths = useMemo(() => {
		const CHILD_ROUTES = [
			ROUTE_LIVE_CASINO,
			ROUTE_LIVE_CASINO_EXPLORE,
			ROUTE_LIVE_CASINO_SUBMENU,
			ROUTE_LIVE_CASINO_ALL_GAMES,
			ROUTE_LIVE_CASINO_MY_GAMES
		];
		return getRelativePaths(CHILD_ROUTES, ROUTE_LIVE_CASINO);
	}, [
		ROUTE_LIVE_CASINO,
		ROUTE_LIVE_CASINO_ALL_GAMES,
		ROUTE_LIVE_CASINO_EXPLORE,
		ROUTE_LIVE_CASINO_MY_GAMES,
		ROUTE_LIVE_CASINO_SUBMENU
	]);

	return (
		<TracedRoutes key="casino-routes">
			<Route
				path={paths[ROUTE_LIVE_CASINO_EXPLORE]}
				element={
					<CasinoSeoHeader
						titleTextKey="LIVE_CASINO_EXPLORE_SITE_TITLE"
						descriptionTextKey="LIVE_CASINO_EXPLORE_META_DESCRIPTION"
						keywordsTextKey="LIVE_CASINO_EXPLORE_META_KEYWORDS"
					/>
				}
			/>
			<Route
				path={paths[ROUTE_LIVE_CASINO_ALL_GAMES]}
				element={
					<CasinoSeoHeader
						titleTextKey="LIVE_CASINO_ALL_GAMES_SITE_TITLE"
						descriptionTextKey="LIVE_CASINO_ALL_GAMES_META_DESCRIPTION"
						keywordsTextKey="LIVE_CASINO_ALL_GAMES_META_KEYWORDS"
					/>
				}
			/>
			<Route
				path={`${paths[ROUTE_LIVE_CASINO_ALL_GAMES]}/:filter`}
				element={
					<CasinoSeoHeader
						titleTextKey="LIVE_CASINO_ALL_GAMES_SITE_TITLE"
						descriptionTextKey="LIVE_CASINO_ALL_GAMES_META_DESCRIPTION"
						keywordsTextKey="LIVE_CASINO_ALL_GAMES_META_KEYWORDS"
					/>
				}
			/>
			<Route
				path={`${paths[ROUTE_LIVE_CASINO_SUBMENU]}/:submenu`}
				element={
					<CasinoSubNavigationSeoHeader
						isLiveCasinoLocation
						titleFallBackTextkey="CASINO_EXPLORE_SITE_TITLE"
					/>
				}
			/>
			<Route
				path={`${paths[ROUTE_LIVE_CASINO_MY_GAMES]}/:filter`}
				element={
					<CasinoSeoHeader
						titleTextKey="LIVE_CASINO_LOVED_GAMES_SITE_TITLE"
						descriptionTextKey="LIVE_CASINO_LOVED_GAMES_META_DESCRIPTION"
						keywordsTextKey="LIVE_CASINO_LOVED_GAMES_META_KEYWORDS"
					/>
				}
			/>
		</TracedRoutes>
	);
};

export default LiveCasinoSeoHeaderContainer;
